import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Hero from "../../components/shared/hero"
import { IBreakpointImageVariants } from "../../design-system/atoms/breakpoint-image"
import { IFluidImageQuery } from "../../design-system/types/imageQuery.types"

interface IHeroStaticQuery {
  sm: IFluidImageQuery
  md: IFluidImageQuery
  lg: IFluidImageQuery
}

const useHeroImages = (): IBreakpointImageVariants => {
  const query = useStaticQuery<IHeroStaticQuery>(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Hero Images/hero 1920.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Hero Images/hero 1440.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Hero Images/hero 360.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const images = Object.keys(query).reduce((acc, current) => {
    acc[current] = query[current].childImageSharp.fluid
    return acc
  }, {})

  return images
}

interface IDeveloperToolsHero {
  title: string
  description: string
}

const DeveloperToolsHero = ({ title, description }: IDeveloperToolsHero) => {
  const images = useHeroImages()
  return (
    <Hero
      overlayStyle={css`
        background-color: var(--tricorn-black);
        mix-blend-mode: multiply;
      `}
      sizes={images}
      title={title}
      description={description}
    />
  )
}

export default DeveloperToolsHero
